import * as moment from 'moment';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { BasePage } from '../../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from './../../../services/auth.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { TokenResponseModel } from './../../../models/auth.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
@Component({
  selector: 'shc-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage extends BasePage implements OnInit {

  form: UntypedFormGroup;
  genderOptions: Array<any> = [
    {
      type: marker('Auth.Form.Male'),
      key: 'male'
    },
    {
      type: marker('Auth.Form.Female'),
      key: 'female'
    },
    {
      type: marker('Auth.Form.Other'),
      key: 'other'
    }
  ];
  customActionSheetOptions: any = {
    header: this.translate.instant(marker('Gender')),
    mode: 'md',
    cssClass: 'removeCancelButton'
  };
  // restriction = moment().subtract(18, 'years').subtract(1, 'day').format('YYYY-MM-DD');


  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private localStorage: Storage
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  ngOnInit() {
    const emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,63}';
    const password = new UntypedFormControl('',
      Validators.compose([Validators.required, Validators.minLength(8)])
    );

    const passwordConfirmation = new UntypedFormControl('', (control: AbstractControl) => {
      if (password.valid && control.value !== password.value) {
        return { confirmed: true };
      }
      return null;
    });
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(50),
        Validators.pattern('^[a-zA-Z ]*$')
      ]),
      username: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]),
      email: new UntypedFormControl(null, [
        Validators.email,
        Validators.required,
        Validators.pattern(emailPattern)
      ]),
      gender: new UntypedFormControl(null),
      date_of_birth: new UntypedFormControl(null),
      password,
      password_confirmation: passwordConfirmation,
      terms_and_service_consent: new UntypedFormControl(false, [
        Validators.required
      ])
    });
  }

  onRegister(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid && !this.form.value.terms_and_service_consent) {
      return;
    }
    // this.form.patchValue({
    //   name: this.form.value.first_name + ' ' + this.form.value.last_name
    // });
    this.showLoader();
    this.authService.register(this.form.value).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(
      (res: TokenResponseModel) => {
        this.router.navigate(['/auth/verify'], { state: { email: this.form.value.email } });
      },
      error => {
        this.errorService.handle(error);
      }
    );
  }

}
